import React , { Component } from 'react';
import { Row, Col, Card, Button, Select, message, Modal } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import StatesSelect, { StatesSelectorType } from '../../components/public/StatesSelect'
import CompanyTable from'./CompanyTable';
import './page-company.less';
import { IMPORT_CUSTOMER_FAILED, IMPORT_CUSTOMER_QUANTITY, IMPORT_CUSTOMER_SKIP, IMPORT_CUSTOMER_SUCCESS_INSERT,IMPORT_DETAIL_MESSAGE } from '../../config/strcfg';
import CustomerService, { ImportCustomerRequest } from '../../service/customer/CustomerService';
import AdminService from '../../service/admin/AdminService';
import CompanyService, { CompanyListRequest, ICompanyInfoList } from '../../service/company/CompanyService';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import SearchSelectComponent, { SearchSelectOption } from '../../components/public/SearchSelectComponent';

interface CompanyPageProps extends RouteComponentProps {
}

interface CompanyPageState {
    nameInputValue: string;
    statesSelectValue: number | null;
    companySelectValue: number | null;
    showAlert :boolean;
    alertMessage: String;
    salesSelectValue: number | null;
    salesList: Array<{id: number, realName: string}>;
    isAssignModalVisible: boolean;
    assignSalesValue: number | null;
    isImportModalVisible: boolean;
    companyMappedInfo: SearchSelectOption[],
    natureSelectValue: string;
}
let response = null;

const STORAGE_KEYS = {
    MY_COMPANY_PAGE: 'myCompanyCurrentPage',
    COMPANY_PAGE: 'companyCurrentPage'
};

//define CompanyPage class
class CompanyPage extends Component<CompanyPageProps, CompanyPageState> {
    state = {
        nameInputValue: '',
        statesSelectValue: 0,
        companySelectValue: null,
        showAlert: false,
        alertMessage: '',
        salesSelectValue: null,
        salesList: [],
        isAssignModalVisible: false,
        assignSalesValue: null,
        isImportModalVisible: false,
        companyMappedInfo: [],
        natureSelectValue: '',
    };

    async componentDidMount() {
        window.addEventListener('popstate', this.handlePopState);
        const storageKey = this.getPageStorageKey();
        const currentPage = parseInt(localStorage.getItem(storageKey) || '1', 10);

        if (this.companyTableRef) {
            this.companyTableRef.setPaginationPage(currentPage);
        }

        if (!this.isMyCompanyPage()) {
            this.getSalesListInfo();
        }
        this.getCompanyDataBasedOnEntry();

        //获取所有公司信息，用于展示公司下拉选择框内容
        const request: CompanyListRequest = {
            companyQueryParam: {
            },
            pageNo: 1,
            pageSize: 99999999,
        };

        const response = this.isMyCompanyPage() ?  
                         await CompanyService.getCompanyByLoginAccount(request): await CompanyService.getCompanyListInfo(request);
     
        if (response) {
            const pageData: ICompanyInfoList = response.data && response.data.companyInfoList ? response.data.companyInfoList : [];
            const CompanyRecords = pageData && pageData.records ? response.data.companyInfoList.records : [];
            const companyMappedInfo = CompanyRecords.map((item: any) => ({
                key: item.id,
                value: item.name,
            }));
            this.setState({ companyMappedInfo: companyMappedInfo});
        }
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    isMyCompanyPage = () => {
        return this.props.location.pathname === '/app/my/company/list';
    };

    getPageTitle = () => {
        return this.isMyCompanyPage() ? '我的客户列表' : '客户信息列表';
    };

    getBreadcrumbs = () => {
        return this.isMyCompanyPage() 
            ? ['我的', '我的客户列表']
            : ['客户信息管理', '客户信息列表'];
    };

    // 获取当前页面对应的 localStorage key
    getPageStorageKey = () => {
        return this.isMyCompanyPage() ? STORAGE_KEYS.MY_COMPANY_PAGE : STORAGE_KEYS.COMPANY_PAGE;
    };

    //监听浏览器返回事件
    handlePopState = () => {
        sessionStorage.setItem('isBackNavigation', 'true');
    };

    //确定进入方式，并获取数据
    getCompanyDataBasedOnEntry = () => {
        const storageKey = this.getPageStorageKey();
        const isBack = sessionStorage.getItem('isBackNavigation') === 'true';
        const pageNo = isBack ? parseInt(localStorage.getItem(storageKey) || '1', 10) : 1;

        // 更新 localStorage
        localStorage.setItem(storageKey, pageNo.toString());
        sessionStorage.removeItem('isBackNavigation');

        if (!isBack) {
            // 通知 CompanyTable 重置分页
            if (this.companyTableRef) {
                this.companyTableRef.setPaginationPage(1);
            }
        }
        // 让 CompanyTable 组件加载数据
        this.companyTableRef.getCompanyTableData(
            pageNo, 
            this.state.nameInputValue, 
            this.state.statesSelectValue,
            this.state.salesSelectValue,
            this.state.natureSelectValue
        );
    };

    companyTableRef: CompanyTable;

    // 获取销售列表
    getSalesListInfo = async () => {
        try {
            const response = await AdminService.getSalesListInfo();
            if (response && response.data && response.data.salesInfo) {
                this.setState({ salesList: response.data.salesInfo });
            } else {
                this.setState({ salesList: [] });
                console.warn('获取销售列表数据为空');
            }
        } catch (error) {
            this.setState({ salesList: [] });
            console.error('获取销售列表失败:', error);
        }
    };

    //公司选择框处理
    CompanySelect = () => {
        const handleCompanySelectChange = (key: number | null, value: string | null) => {
            this.setState({ companySelectValue: key, nameInputValue: value }, () => {
                // 状态更新后重新加载数据
                if (this.companyTableRef) {
                    this.companyTableRef.getCompanyTableData(
                        1, 
                        this.state.nameInputValue, 
                        this.state.statesSelectValue,
                        this.state.salesSelectValue,
                        this.state.natureSelectValue
                    );
                    this.companyTableRef.setPaginationPage(1);
                }
            });
        };
     
        const handleClear = () => {
            this.setState({ companySelectValue: null, nameInputValue: null }, () => {
                // 状态更新后重新加载数据
                if (this.companyTableRef) {
                    this.companyTableRef.getCompanyTableData(
                        1, 
                        this.state.nameInputValue, 
                        this.state.statesSelectValue,
                        this.state.salesSelectValue,
                        this.state.natureSelectValue
                    );
                    this.companyTableRef.setPaginationPage(1);
                }
            });
        };
    
        return (
            <>
                <label className="label-customer_company">公司名：</label>
                <SearchSelectComponent 
                    placeholder="请输入客户公司名"
                    optionProps={this.state.companyMappedInfo} 
                    initialValues={this.state.companySelectValue}
                    onChange={handleCompanySelectChange}
                    onClear={handleClear}
                    disabled={false} 
                    allowClear
                    returnInputValue
                />
            </>
        );
    };

    //销售选择框处理
    SalesSelect = () => {
        return (
            <>
                <label className="label-company_sales">销售：</label>
                <Select 
                    className="select-company_sales"
                    onChange={(value) => {
                        // value 为 undefined 或 null 时表示点击了清除按钮
                        this.setState({ 
                            salesSelectValue: value !== undefined && value !== null ? value : null
                        }, () => {
                            // 状态更新后重新加载数据
                            this.companyTableRef.getCompanyTableData(
                                1,
                                this.state.nameInputValue,
                                this.state.statesSelectValue,
                                this.state.salesSelectValue,
                                this.state.natureSelectValue
                            );
                        });
                        if (this.companyTableRef) {
                            this.companyTableRef.setPaginationPage(1);
                        }
                    }}
                    value={this.state.salesSelectValue !== null ? this.state.salesSelectValue : undefined}
                    allowClear
                    placeholder="请选择"
                >
                    <Select.Option value={0}>未分配</Select.Option>
                    {this.state.salesList && this.state.salesList.map(item => (
                        <Select.Option key={item.id} value={item.id}>
                            {item.realName}
                        </Select.Option>
                    ))}
                </Select>
            </>
        );
    };

    //状态选择框事件处理
    handleStatesSelectChange = (value: any) => {
        this.setState({ statesSelectValue: value });
    };

    //公司性质选择框事件处理
    handleNatureSelectChange = (value: string) => {
        this.setState({ natureSelectValue: value });
    };

    //查询按钮点击事件
    handleQueryButtonClick = async () => {
        await this.companyTableRef.getCompanyTableData(
            1, 
            this.state.nameInputValue, 
            this.state.statesSelectValue,
            this.state.salesSelectValue,
            this.state.natureSelectValue
        );
        if (this.companyTableRef) {
            this.companyTableRef.setPaginationPage(1);
        }
    };

    //指派销售按钮点击事件
    handleAssignButtonClick = () => {
        // 检查是否有选中的公司
        const selectedCompanies = this.companyTableRef.state.selectedRowKeys;
        if (!selectedCompanies || selectedCompanies.length === 0) {
            message.warning('请先选择要指派的公司');
            return;
        }
        this.setState({ isAssignModalVisible: true });
    };

    // 处理销售选择改变
    handleAssignSalesChange = (value: number | null) => {
        this.setState({ assignSalesValue: value });
    };

    // 处理提交按钮点击
    handleAssignSubmit = async () => {
        try {
            const selectedCompanies = this.companyTableRef.state.selectedRowKeys;
            const response = await CompanyService.assignSalesByCompanyIds({
                companyIds: selectedCompanies,
                salesId: this.state.assignSalesValue
            });

            if (response && response.success) {
                message.success('指派成功');
                this.setState({ 
                    isAssignModalVisible: false,
                    assignSalesValue: null
                });
                // 重新加载表格数据，并保持在当前页
                const storageKey = this.getPageStorageKey();
                const currentPage = parseInt(localStorage.getItem(storageKey) || '1', 10);
                
                await this.companyTableRef.getCompanyTableData(
                    currentPage,
                    this.state.nameInputValue,
                    this.state.statesSelectValue,
                    this.state.salesSelectValue,
                    this.state.natureSelectValue // 确保传递公司性质
                );
            }
        } catch (error) {
            console.error('指派销售失败:', error);
            message.error('指派失败，请稍后重试');
        }
    };

    // 处理取消按钮点击
    handleAssignCancel = () => {
        this.setState({ 
            isAssignModalVisible: false,
            assignSalesValue: null
        });
    };

    //导入客户信息按钮点击事件
    handleImportButtonClick = async () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.xlsx, .xls, .cvs'; 
        input.onchange = (event) => {
            const target = event.target as HTMLInputElement;
            const file = target.files && target.files[0];
            const reader = new FileReader();
            reader.onload = async (e) => {
                const request: ImportCustomerRequest = {
                    file: file
                };
                response = await CustomerService.importCustomer(request);
                if(response && response.data){
                    const importMessage = 
                    IMPORT_CUSTOMER_SUCCESS_INSERT + response.data.success + IMPORT_CUSTOMER_QUANTITY + '\n' +
                    IMPORT_CUSTOMER_FAILED + response.data.fail + IMPORT_CUSTOMER_QUANTITY + '\n' + 
                    IMPORT_CUSTOMER_SKIP + response.data.skip + IMPORT_CUSTOMER_QUANTITY + '\n' + 
                    IMPORT_DETAIL_MESSAGE + response.data.message ;
                                    
                    this.setState({ 
                        showAlert: true,
                        alertMessage: importMessage,
                        isImportModalVisible: true
                    });
                }
            };
            reader.readAsText(file); // Read the file as text
        };
        input.click();                                      
    };

    handleCloseImportMessgaeModal = () => {
        this.setState({ isImportModalVisible: false });
    }

    render() {
        return (
            <ErrorBoundary>
                <div className="gutter-company_container">
                    <BreadcrumbCustom breads={this.getBreadcrumbs()} />
                    <Row gutter={5}>
                        <Col className="gutter-company_row" md={25}>
                            <div className="gutter-company_box">
                                <Card title={<div className="title-list_page">客户信息列表</div>} bordered={false}>
                                    <div style={{ marginBottom: 16 }}>
                                        <this.CompanySelect />

                                        {!this.isMyCompanyPage() && <this.SalesSelect />}

                                        <label className="label-company_states">状态：</label>
                                        <StatesSelect 
                                            selectorType={StatesSelectorType.company}
                                            onChange={this.handleStatesSelectChange}
                                        />

                                        <label className="label-company_nature" style={{ marginLeft: '16px' }}>公司性质：</label>
                                        <Select
                                            className="select-company_nature"
                                            style={{ width: 120, marginRight: 8 }}
                                            value={this.state.natureSelectValue}
                                            onChange={this.handleNatureSelectChange}
                                        >
                                            <Select.Option value="">全部</Select.Option>
                                            <Select.Option value="民营">民营</Select.Option>
                                            <Select.Option value="外资">外资</Select.Option>
                                            <Select.Option value="国有">国有</Select.Option>
                                            <Select.Option value="合资">合资</Select.Option>
                                            <Select.Option value="事业">事业</Select.Option>
                                        </Select>

                                        <Button className="button-company_query" type="primary" onClick={this.handleQueryButtonClick}>   
                                            查询
                                        </Button>
                                        
                                        {!this.isMyCompanyPage() &&
                                        <Button className="button-assign-sales" type="primary" onClick={this.handleAssignButtonClick}>   
                                            指派销售
                                        </Button>
                                        }

                                        {!this.isMyCompanyPage() &&
                                        <Button className="button-import" type="primary" onClick={this.handleImportButtonClick}>
                                            客户导入
                                        </Button>
                                        }
                                    </div>
                                    <div className="company-table-wrapper">
                                    <CompanyTable
                                        ref={(ref) => (this.companyTableRef = ref)}
                                        nameInputValue={this.state.nameInputValue}
                                        statesSelectValue={this.state.statesSelectValue}
                                        salesSelectValue={this.state.salesSelectValue}
                                        natureSelectValue={this.state.natureSelectValue}
                                        isMyCompanyPage={this.isMyCompanyPage()}
                                    />
                                    </div>
                                </Card>
                            </div>
                        </Col>
                    </Row>

                    <Modal
                        title="指派销售"
                        visible={this.state.isAssignModalVisible}
                        onOk={this.handleAssignSubmit}
                        onCancel={this.handleAssignCancel}
                        okText="确定"
                        cancelText="取消"
                    >
                        <div style={{ marginBottom: 16 }}>
                            <label style={{ marginRight: 8 }}>选择销售：</label>
                            <Select
                                style={{ width: 200 }}
                                placeholder="请选择销售"
                                value={this.state.assignSalesValue}
                                onChange={this.handleAssignSalesChange}
                            >
                                <Select.Option value={null}>移除已指派销售</Select.Option>
                                {this.state.salesList.map(item => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.realName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                    </Modal>

                    <Modal
                        title="导入结果"
                        visible={this.state.isImportModalVisible}
                        onOk={this.handleCloseImportMessgaeModal}
                        onCancel={this.handleCloseImportMessgaeModal}
                        okText="确定"
                        cancelText="取消"
                    >
                        <p style={{ whiteSpace: 'pre-line' }}>{this.state.alertMessage}</p>
                    </Modal>
                </div>
            </ErrorBoundary>
        );
        
    }
}

export default withRouter(CompanyPage);